import {useState, useRef} from 'react';
import type {MouseEvent} from 'react';
import LogoPrimary from '@/svg/logos/logoPrimary';
import Link from '@/links';
import Img from '@/images';
import useOnClickOutside from '@/hooks/useClickOutside';
import styles from './logo-dropdown.module.scss';

interface LogoDropdownProps {
  lightHeader?: boolean;
}

const LogoDropdown = ({lightHeader = false}: LogoDropdownProps) => {
  const logoKitRef = useRef<HTMLDivElement | null>(null);
  const [showMenu, setShowMenu] = useState(false);

  const closeLogoKit = () => {
    document.querySelector('html')?.classList.remove('non-scrollable');
    setShowMenu(false);
  };

  useOnClickOutside(logoKitRef, () => closeLogoKit());

  const toggleLogoKit = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    document.querySelector('html')?.classList.toggle('non-scrollable');
    setShowMenu(curr => !curr);
  };

  return (
    <div
      role="menu"
      tabIndex={0}
      ref={logoKitRef}
      className={styles['header-logo']}
      onContextMenu={toggleLogoKit}>
      <Link href="/" title="Workable logo">
        <LogoPrimary lightHeader={lightHeader} />
      </Link>

      {showMenu && (
        <ul className={styles['context-menu']}>
          <li>
            <Link href="/static/downloads/logo-kit.zip" target="_blank">
              <div className={styles['context-menu__item']}>
                <span className={styles['context-menu__item-icon']}>
                  <Img src="/static/images/menu/logo-kit.svg" alt="Workable logo kit icon" width={32} />
                </span>
                <div className={styles['context-menu__item-copy']}>
                  <span className={styles['context-menu__item-title']}>Download</span>
                  <span className={styles['context-menu__item-note']}>Logo kit</span>
                </div>
              </div>
            </Link>
          </li>
        </ul>
      )}
    </div>
  );
};

export default LogoDropdown;
